(function () {
  'use strict';

  function applyFormsStyles(formsEmbed) {
    if (!formsEmbed || !formsEmbed.shadowRoot) {
      return false;
    }

    const shadowRoot = formsEmbed.shadowRoot;

    // Don't add the stylesheet more than once.
    if (shadowRoot.querySelector('#custom-campaign-forms-styles')) {
      return true;
    }

    const style = document.createElement('style');

    style.id = 'custom-campaign-forms-styles';

    style.textContent = `
      :host {
        section[role="dialog"] * {
            line-height: 1.5;
            margin: 0;
        }
        span[role="button"] {
            position: absolute;
            top: -11px;
            right: -15px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        span[role="button"] > svg {
            fill-opacity: 1;
            width: 14px;
            height: 14px;
        }
        section[role="dialog"] h2 {
            line-height: 1.25;
            margin: 0 12px 12px 0;
        }
        section[role="dialog"] p {
            line-height: 1.375;
        }
        section[role="dialog"] form {
            margin-top: 12px;
        }
        button[data-testid="form-teaser"] {
            padding: 16px 44px 16px 24px;
            max-width: 440px;
        }
        button[data-testid="form-teaser"] h3 {
            font-size: 16px;
        }
        button[data-testid="form-teaser"] span[role="button"] {
            top: 50%;
            transform: translateY(-50%);
            right: 20px;
        }
        button[data-testid="form-teaser"] span[role="button"] > svg {
            width: 12px;
            height: 12px;
        }

        --min-form-width: 200px !important;

        --spacing-size: 12px;
        --spacing-size-y: 32px;
        --spacing-size-x: 32px;

        --forms-body-font: normal 400 16px HankenGrotesk-Regular, sans-serif;
        --forms-heading-font: normal 600 20px HankenGrotesk-Regular, sans-serif;

        --button-background-color: #000;
        --button-background-color-hovered-modifier: opacity(100%);

        --container-text-alignment: left;
        --disclaimer-padding: 0px;

        --form-field-border: 0 0 0 1px #000;
        --form-field-border-focused: 0 0 0 2px #000;

        --form-text-color: #000;
        --form-placeholder-color: rgba(0,0,0,0.75);

        --form-field-border-radius: 8px;
        --button-border-radius: 8px;
        --container-border-radius: 12px;
      }
    `;

    shadowRoot.appendChild(style);

    return true;
  }

  function findForms() {
    const formsEmbed = document.querySelector('shopify-forms-embed');

    if (!formsEmbed) {
      return false;
    }

    return applyFormsStyles(formsEmbed);
  }

  /*
   * Forms may load asynchronously.
   */
  if (!findForms()) {
    const observer = new MutationObserver(function () {
      if (findForms()) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();